import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const repairReasonsAdapter = getAdapter({ idFieldName: 'value' });

const repairReasonsSlice = createSlice({
  name: 'repairReasons',
  initialState: repairReasonsAdapter.getInitialState(),
  reducers: {
    setRepairReasons: (state, { payload: { repairReasons } }) => {
      repairReasonsAdapter.setAll(state, repairReasons);
    },
  },
});

const selectors = repairReasonsAdapter.getSelectors(({ repairReasons }) => repairReasons);

export const getRepairReasons = (state) => selectors.selectAll(state);

export const {
  setRepairReasons,
} = repairReasonsSlice.actions;

export default repairReasonsSlice.reducer;
